// Mock de técnicos para desenvolvimento
const mockTechnicians = [
  {
    _id: '1',
    displayName: 'João Silva',
    email: 'joao.silva@bynnor.com',
    role: 'technician',
    isActive: true
  },
  {
    _id: '2',
    displayName: 'Maria Oliveira',
    email: 'maria.oliveira@bynnor.com',
    role: 'technician',
    isActive: true
  },
  {
    _id: '3',
    displayName: 'Carlos Santos',
    email: 'carlos.santos@bynnor.com',
    role: 'technician',
    isActive: true
  },
  {
    _id: '4',
    displayName: 'Ana Pereira',
    email: 'ana.pereira@bynnor.com',
    role: 'technician',
    isActive: true
  },
  {
    _id: '5',
    displayName: 'Pedro Costa',
    email: 'pedro.costa@bynnor.com',
    role: 'technician',
    isActive: true
  }
];

export default mockTechnicians;
